import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { FadeUp } from "../components/Reveal";
import { ArrowRight } from "lucide-react";

const NotFound = () => (
  <div data-testid="not-found-page">
    <SEO
      title="Page Not Found | Lunar Ambitions"
      description="The page you are looking for could not be found. Lunar Ambitions, licensed esthetician studio in Orlando, FL."
      robots="noindex, follow"
      skipCanonical
    />
    <section className="relative overflow-hidden bg-white pt-36 pb-28 min-h-[85vh] flex items-center">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 w-full text-center">
        <FadeUp delay={0.05}>
          <img
            src="/images/404.webp"
            alt="Page not found, Lunar Ambitions skin care in Orlando, Florida"
            className="w-full max-w-xl mx-auto h-auto"
            data-testid="not-found-image"
          />
        </FadeUp>
        <FadeUp delay={0.3}>
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="group mt-4 inline-flex items-center gap-3 bg-navy text-white text-sm tracking-[0.18em] uppercase font-medium px-9 py-4 transition-colors duration-300 hover:bg-gold hover:text-navy"
          >
            Back to Home
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </FadeUp>
      </div>
    </section>
  </div>
);

export default NotFound;
